import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance for direct use
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;

// Shopify Products API
export const fetchProducts = async () => {
  try {
    const response = await axios.get(`${API}/shopify/products`);
    return response.data.products;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const fetchProductByHandle = async (handle) => {
  try {
    const response = await axios.get(`${API}/shopify/products/${handle}`);
    return response.data.product;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

export const fetchCollections = async () => {
  try {
    const response = await axios.get(`${API}/shopify/collections`);
    return response.data.collections;
  } catch (error) {
    console.error('Error fetching collections:', error);
    throw error;
  }
};

// Newsletter API
export const subscribeNewsletter = async (email) => {
  try {
    const response = await axios.post(`${API}/newsletter/subscribe`, { email });
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};

// Contact Form API
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact`, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};
